import React, { createContext, useContext, useState, useMemo } from 'react';

const DgiiCargaContext = createContext(null);

export function DgiiCargaProvider({ children }) {
	// Timestamp de inicio de sesión de carga (segundos) para mostrar Estado de Cola al volver de otra ruta
	const [colaTimestampInicio, setColaTimestampInicio] = useState(null);

	const value = useMemo(
		() => ({ colaTimestampInicio, setColaTimestampInicio }),
		[colaTimestampInicio]
	);

	return (
		<DgiiCargaContext.Provider value={value}>
			{children}
		</DgiiCargaContext.Provider>
	);
}

export function useDgiiCarga() {
	const ctx = useContext(DgiiCargaContext);
	return ctx || { colaTimestampInicio: null, setColaTimestampInicio: () => {} };
}
